import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import { getApiUrl } from "../../utils/apiUrls";
import instance from "../../utils/axios";
import { useDispatch, useSelector } from "react-redux";
import { apiErrorHandler } from "../../utils/errorHandler";
import moment from "moment/moment";
import { saveAs } from "file-saver";
import { openSnackBar } from "../../redux/actions/snackbar.actions";
import { ReactComponent as ExcelIcon } from "../../assets/images/document/Excel.svg";
import { ReactComponent as PdfIcon } from "../../assets/images/document/Pdf.svg";
import { ReactComponent as PowerIcon } from "../../assets/images/document/Power.svg";
import { ReactComponent as WordIcon } from "../../assets/images/document/Word.svg";
import { ReactComponent as ZipIcon } from "../../assets/images/document/Zip.svg";
import { ReactComponent as EmptyData } from "../../assets/images/global/empty-data.svg";
import DocumentCardItem from "../../components/available-events-item/DocumentCardItem.component";
import axios from "axios";

const populateIcon = (val) => {
  if (val) {
    switch (val) {
      case "doc":
      case "docx":
        return <WordIcon />;
      case "pdf":
        return <PdfIcon />;
      case "xlsx":
      case "xls":
        return <ExcelIcon />;
      case "zip":
        return <ZipIcon />;
      case "pptx":
      case "ppt":
        return <PowerIcon />;
      default:
        return;
    }
  }
  return (
    <FontAwesomeIcon
      icon={regular("paperclip")}
      className="cm-sm-txt text-blue-gray-700 bg-blue-gray-50 my-auto"
    />
  );
};

const extensionKey = {
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ppt: "application/vnd.ms-powerpoint",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  pdf: "application/pdf",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  zip: "application/zip"
}

const keySetter = {
  VIEW_ONLY: "v",
  VIEW_DOWNLOAD: "d",
  INTERVIEW: "I",
  GROUP_DISCUSSION: "G",
  TEST: "T",
  ASSESSMENT: "T",
};

const DocumentContent = ({
  t,
  taskType,
  eventId,
  documentData,
  contentHeight,
}) => {
  const dispatch = useDispatch();
  const envState = useSelector((state) => state.env);

  const timeFrameHandler = (startTime, endTime) => {
    return !moment().isBetween(startTime, endTime, "minutes", "[]");
  };
  const handleDownload = async (documentId, documentName) => {
    try {
      const res = await instance.get(
        `${getApiUrl(
          envState.PRODUCTION
            ? "downloadDocumentFile"
            : "viewDownloadDocumentFileLocal"
        )}/${eventId}/${documentId}/${taskType}/DOWNLOAD`, envState.PRODUCTION ? {
          responseType: "blob",
        } : {}
      );
      if (envState.PRODUCTION) {
        const blob = new Blob([res.data], { type: extensionKey[documentName?.split(".")[1]] });
        saveAs(blob, documentName);
      }
      else {
        await axios.get(res.data)
        saveAs(res.data, documentName);
      }
    } catch (err) {
      if (envState.PRODUCTION) {
        const errorMes = new Promise((resolve, reject) => {
          let reader = new FileReader();
          reader.onload = () => {
            err.response.data = JSON.parse(reader.result);
            const msgObj = apiErrorHandler(err);
            dispatch(
              openSnackBar({
                msg: t(msgObj.statusText),
                type: "error",
              })
            );
            resolve(Promise.reject(err));
          };

          reader.onerror = () => {
            reject(err);
          };
          reader.readAsText(err.response.data);
        });
      }
      else {
        const msgObj = apiErrorHandler(err);
        dispatch(
          openSnackBar({
            msg: t(msgObj.statusText),
            type: "error",
          })
        );
      }
    }
  };
  return (
    <>
      {documentData?.length > 0 ? (
        documentData.map((el) => (
          <DocumentCardItem
            t={t}
            key={el.documentId}
            populateIcon={populateIcon}
            data={el}
            handleDownload={handleDownload}
            keySetter={keySetter}
            taskType={taskType}
            timeFrameHandler={timeFrameHandler}
            eventId={eventId}
          />
        ))
      ) : (
        <div
          className="d-flex align-items-center justify-content-center flex-column pt-4 mt-1"
          style={{
            height: !!contentHeight ? `${contentHeight}px` : "auto"
          }}
        >
          <EmptyData />
          <p className="my-0 text-blue-700 fw-semibold cm-sm-txt">
            {t("nothing_to_see")}
          </p>
        </div>
      )}
    </>
  );
};

export default DocumentContent;
